import { render, staticRenderFns } from "./ShowVideo.vue?vue&type=template&id=33f8cd53&scoped=true"
import script from "./ShowVideo.vue?vue&type=script&lang=js"
export * from "./ShowVideo.vue?vue&type=script&lang=js"
import style0 from "./ShowVideo.vue?vue&type=style&index=0&id=33f8cd53&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f8cd53",
  null
  
)

export default component.exports